export default __webpack_public_path__ + "static/media/mission_medium.bf19e819.jpg";